const cache = new Map<string, string>();

export async function loadSound(path: string) {
  if (!cache.has(path)) {
    const response = await fetch(path);
    const buffer = await response.arrayBuffer();
    const blob = new Blob([buffer], { type: "audio/wav" });
    const blobUrl = URL.createObjectURL(blob);
    cache.set(path, blobUrl);
  }

  return cache.get(path);
}

export async function playSound(path: string) {
  const cachedPath = await loadSound(path);
  const a = new Audio(cachedPath);
  a.play();
}
